export default "__VITE_ASSET__BfOZUP0a__"